import { Row, Heading } from "@stenajs-webui/core";

export const renderHeadingCenter = (label: string | undefined) => {
  return (
    <Row width={"100%"} display={"flex"} justifyContent={"center"}>
      <Heading variant="h5">{label}</Heading>
    </Row>
  );
};
